var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 17.096 0.1105 18.1661 0.320437 19.2001L16 20.174L31.6796 19.2001C31.8896 18.1661 32 17.096 32 16.0001C32 14.9041 31.8895 13.834 31.6796 12.8001L16 11.8261L0.320437 12.8001C0.1105 13.834 0 14.9041 0 16.0001H0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6797 19.2H0.320557C1.80299 26.5031 8.25956 32 16.0001 32C23.7407 32 30.1972 26.5031 31.6797 19.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.320557 12.8H31.6798C30.1972 5.49688 23.7408 0 16.0001 0C8.25943 0 1.80299 5.49688 0.320557 12.8V12.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9567 12.8H9.0437L11.8862 11.4629L10.3725 8.71007L13.4591 9.30038L13.8503 6.18231L16.0002 8.47569L18.1502 6.18231L18.5412 9.30038L21.6279 8.71007L20.1143 11.463L22.9567 12.8Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8365 7.1635 32 16 32L3.19975 6.39941C1.19075 9.07373 0 12.3977 0 16Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 12.3977 30.8092 9.07373 28.8002 6.39941L16 32Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/AG.78d8e666.svg";
export { ForwardRef as ReactComponent };